module.exports = __webpack_public_path__ + "static/media/sara-stedy-mobility-aid.105e3a05.png";